import { IControl, IControlType, IBindingRule } from '@se/cp.common';
import { Guid } from '@se/se.platform.base';

export type ControlTypeGroup =
    | 'AnatomicalMap'
    | 'MultiStageMap'
    | 'Autocomplete'
    | 'Combo'
    | 'DateTime'
    | 'Generic'
    | 'Graph'
    | 'Grid'
    | 'Import'
    | 'Input'
    | 'MultiSelector'
    | 'Numeric'
    | 'Radio'
    | 'Selector'
    | 'TabSelector'
    | 'TextEditor'
    | 'Unknown'
    | 'UserControl'
    | 'MapContainer'
    | 'Measure'
    | 'GridDefaultGroups';

export abstract class CpControl {
    readonly controlTypeGroup!: ControlTypeGroup;

    controlType: IControlType;
    column: number;
    columnSpan: number;
    row: number;
    rowSpan: number;
    id: string;
    idPanelItem: string | null;
    isWithLabel: boolean;
    name: string;
    constraints: IBindingRule[];

    protected height?: number;

    /**
     * Utilizzare cpControlFactory
     */
    protected constructor(control: IControl) {
        if (control.id && control.id !== Guid.EMPTY) {
            this.id = control.id;
        } else {
            this.id = new Guid().toString();
        }

        this.columnSpan = control.columnSpan || 1;
        this.controlType = control.controlType;
        this.column = control.column || 0;
        this.row = control.row || 0;
        this.idPanelItem = control.idPanelItem || null;
        this.isWithLabel = control.isWithLabel;
        this.name = control.name;
        this.rowSpan = control.rowSpan || 1;
        this.constraints = control.constraints || [];
    }

    abstract canAlignToBottom(): boolean;

    abstract getHeightHint(): number;

    getHeight() {
        return this.height ?? 0;
    }

    setHeight(height: number) {
        this.height = height;
    }
}
